import { CircularProgress } from '@mui/material';
import { FlexDiv } from 'crono-fe-common/components/Layout/FlexDiv';
import { useAccountDrawer } from 'context/accountDrawer';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PATH from 'crono-fe-common/constants/path';
import { useCustomLocation } from 'context/customLocation';

const CompanyInterceptor = () => {
  const [searchParams] = useSearchParams();
  const accountId = searchParams.get('accountId') ?? undefined;
  const openScoreParam = searchParams.get('openScore');
  const shouldOpenScore = openScoreParam === 'true' || openScoreParam === '1';
  const { openAccountDrawer } = useAccountDrawer();

  const navigate = useNavigate();
  const { setCustomStateLocation } = useCustomLocation();

  useEffect(() => {
    navigate(PATH.LISTS);
    setCustomStateLocation({
      listsPageTabState: 'Company',
    });

    if (!accountId) {
      console.error(`Tried opening company but found accountId: ${accountId}`);
      return;
    }

    openAccountDrawer({ accountId, openScore: shouldOpenScore });
  }, [accountId]);

  return (
    <FlexDiv>
      <CircularProgress />
    </FlexDiv>
  );
};

export default CompanyInterceptor;
